import callAPI from '../ApiConfig'
import Cookies from 'universal-cookie'

const cookies = new Cookies()

// Backend auth (src/jwt/auth.js -> validateUser) reads the session credentials
// from req.query (username, user_id, account_id, account_name, sid, baseurl...).
// Other pages send these as a "headerObject" spread into params; we centralize
// it here so every filter-visibility request is authenticated automatically.
const authParams = () => ({
    username: cookies.get('user_name') ? cookies.get('user_name') : null,
    user_id: cookies.get('user_id') ? cookies.get('user_id') : null,
    account_name: cookies.get('account_name') ? cookies.get('account_name') : null,
    account_id: cookies.get('account_id') ? cookies.get('account_id') : null,
    authHash: cookies.get('authHash') ? cookies.get('authHash') : null,
    sid: cookies.get('sid') ? cookies.get('sid') : null,
    baseurl: cookies.get('baseUrl') ? cookies.get('baseUrl') : null,
    id: cookies.get('id') ? cookies.get('id') : null,
    accessible_accounts_ids: cookies.get('accessible_accounts_ids') ? cookies.get('accessible_accounts_ids') : null,
})

// GET /filter_visibility?page_key=...  -> [{ page_key, filter_key, visibility }]
const getFilterVisibility = async (props) => {
    return await callAPI({
        route: "filter_visibility/",
        method: "get",
        signal: props?.signal,
        params: { ...authParams(), ...props?.params },
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        }
    })
}

// PUT /filter_visibility  body: { page_key, filter_key, visibility: 'public'|'private' }
// Auth goes in params (validateUser reads req.query); payload goes in the body
// (controller reads req.body).
const updateFilterVisibility = async (props) => {
    return await callAPI({
        route: "filter_visibility/",
        method: "put",
        params: { ...authParams() },
        data: props?.data,
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        }
    })
}

const filterVisibilityAPI = {
    getFilterVisibility,
    updateFilterVisibility,
}

export default filterVisibilityAPI
